export default __webpack_public_path__ + "postMock-1758535243410.html";